var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInteraction = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M9.225 6.452A2.775 2.775 0 0 1 12 3.677v0a2.775 2.775 0 0 1 2.775 2.775v0A2.775 2.775 0 0 1 12 9.227v0a2.777 2.777 0 0 1-2.775-2.775M2.5 17.548a2.775 2.775 0 0 1 2.775-2.775v0a2.775 2.775 0 0 1 2.775 2.775v0a2.776 2.776 0 0 1-2.775 2.775v0A2.774 2.774 0 0 1 2.5 17.548M15.951 17.548a2.775 2.775 0 0 1 2.775-2.775v0a2.775 2.775 0 0 1 2.775 2.775v0a2.775 2.775 0 0 1-2.775 2.775v0a2.774 2.774 0 0 1-2.775-2.775",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "m8.49 11.92-2.01 3.14M13.5 8.78l2.01 3.14M15.95 17.55H12"
})));
export default SvgInteraction;